import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Select,
  Option,
  Input,
  InputNumber,
  Radio,
  Dialog,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  DatePicker,
  Form,
  FormItem,
  Table,
  TableColumn,
  Tag,
  Button,
  ButtonGroup,
  Pagination,
  Badge,
  Loading,
  Message,
  MessageBox,
  Notification,
  Menu,
  MenuItem,
  Submenu,
  RadioGroup,
  RadioButton,
  Popconfirm,
  Popover,
  Rate,
  Upload,
  Timeline,
  TimelineItem,
  Card,
  Row,
  Col,
  PageHeader,
  Step,
  Steps,
  Divider,
  Tooltip,
  Tabs,
  TabPane,
  Drawer,
  Empty,
  Image,
} from 'element-ui'
const element = {
  install: function (Vue: any) {
    Vue.use(Dropdown)
    Vue.use(DropdownMenu)
    Vue.use(DropdownItem)
    Vue.use(Select)
    Vue.use(Option)
    Vue.use(Input)
    Vue.use(InputNumber)
    Vue.use(Radio)
    Vue.use(Dialog)
    Vue.use(Checkbox)
    Vue.use(CheckboxButton)
    Vue.use(CheckboxGroup)
    Vue.use(Switch)
    Vue.use(DatePicker)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Tag)
    Vue.use(Button)
    Vue.use(ButtonGroup)

    Vue.use(Pagination)
    Vue.use(Badge)
    Vue.use(Loading)
    Vue.use(Menu)
    Vue.use(MenuItem)
    Vue.use(Submenu)
    Vue.use(RadioGroup)
    Vue.use(RadioButton)
    Vue.use(Popconfirm)
    Vue.use(Popover)
    Vue.use(Rate)
    Vue.use(Upload)
    Vue.use(Timeline);
    Vue.use(TimelineItem);
    Vue.use(Card)
    Vue.use(Col)
    Vue.use(Row)
    Vue.use(PageHeader)
    Vue.use(Step)
    Vue.use(Steps)
    Vue.use(Divider)
    Vue.use(Tooltip)
    Vue.use(Tabs)
    Vue.use(TabPane)
    Vue.use(Drawer)
    Vue.use(Empty)
    Vue.use(Image)
    Vue.prototype.$message = Message;
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$prompt = MessageBox.prompt;
    Vue.prototype.$notify = Notification;

  }
}

export default element
